import { ExclamationIcon } from '~/components/design-system/icons';
import {
  LazyAccountResponsibleGamingAccountLock,
  LazyAccountResponsibleGamingAccountRestricted,
  LazyAccountResponsibleGamingAccountUnlocked,
  LazyAccountResponsibleGamingCoolingOffPeriod,
  LazyAccountResponsibleGamingLimitsInformation,
  LazyAccountResponsibleGamingSessionLimitExceeded,
  LazyAccountResponsibleGamingWagerLimitExceeded,
} from '#components';
import type { TModalConfig } from '~/interfaces/content/modals';

export const rgModals: TModalConfig = {
  accountLocked: {
    modalProps: {
      title: 'account-locked',
      headerIcon: ExclamationIcon,
      headerIconClass: 'text-error-500 w-6 h-6',
      iconTooltip: 'account-lock-tooltip',
      showClose: false,
    },
    component: () => LazyAccountResponsibleGamingAccountLock,
  },
  accountRestricted: {
    modalProps: {
      title: 'account-restricted',
      headerIcon: ExclamationIcon,
      headerIconClass: 'text-gold-500 w-6 h-6',
      iconTooltip: 'account-restricted-tooltip',
    },
    component: () => LazyAccountResponsibleGamingAccountRestricted,
  },
  accountUnlocked: {
    modalProps: {
      title: 'account-unlocked',
      headerIcon: ExclamationIcon,
      headerIconClass: 'text-primary-blue-600 w-6 h-6',
      iconTooltip: 'account-unlocked-tooltip',
    },
    component: () => LazyAccountResponsibleGamingAccountUnlocked,
  },
  rGExclusionMessage: {
    modalProps: {
      title: 'cooling-off-period',
    },
    component: () => LazyAccountResponsibleGamingCoolingOffPeriod,
  },
  rGLimitsMessage: {
    modalProps: {
      title: 'limits',
    },
    component: () => LazyAccountResponsibleGamingLimitsInformation,
  },
  sessionLimitExceeded: {
    modalProps: {
      title: 'session-limit-exceeded',
      headerIcon: ExclamationIcon,
      headerIconClass: 'text-gold-500 w-6 h-6',
      iconTooltip: 'session-limit-tooltip',
      showClose: false,
    },
    component: () => LazyAccountResponsibleGamingSessionLimitExceeded,
  },
  wagerLimitExceeded: {
    modalProps: {
      title: 'wager-limit-exceeded',
      headerIcon: ExclamationIcon,
      headerIconClass: 'text-gold-500 w-6 h-6',
      iconTooltip: 'wager-limit-tooltip',
      showClose: false,
    },

    component: () => LazyAccountResponsibleGamingWagerLimitExceeded,
  },
} as const satisfies TModalConfig;
